import React, { useEffect } from 'react';
import './PricesSection.css';
import NavBar from '../components/Nav';
import Footer from '../components/footer';
import ScrollTop from '../components/Scrolltop';
import Whatsapp from '../components/Whatsapp';
import { Link } from "react-router-dom";


const PricesSection = () => {
      useEffect(() => {
          window.scrollTo(0, 0);
        }, []);
    const services = [
        { title: 'Federal Return (1040)', price: '$39.99' },
        { title: 'Federal Return (1040-NR)', price: '$59.99' },
        { title: 'Each State Return', price: '$39.99' },
        { title: 'City & County Returns', price: '$39.99' },
        { title: 'FBAR / FATCA Filing', price: '$39.99' },
        { title: 'Schedule C, E, F, H', price: '$119.99' },
        { title: 'ITIN Application', price: '$219.99' },
        { title: 'ITIN Application (Non Resident)', price: '$299.99' },
        { title: 'Amended Return', price: '$149.99' },
        { title: 'Business Incorporation', price: '$249.99' },
        { title: 'LLC / Partnership Return (1065)', price: '$249.99' },
        { title: 'S Corporation (1120-S)', price: '$249.99' },
        { title: 'Corporation (1120)', price: '$249.99' },
        { title: 'Estate and Trusts (1041)', price: '$249.99' },
        { title: 'Estate Tax Return (706)', price: '$249.99' },
        { title: 'Gift Tax Return (709)', price: '$249.99' },
        { title: 'Bookkeeping & Accounting', price: '$14.99/hr' },
        { title: 'Half-Time Bookkeeping (80 Hrs)', price: '$11.99/hr' },
        { title: 'Full-Time Bookkeeping (160 Hrs)', price: '$9.99/hr' },
        { title: 'Financial Review with Tax Experts', price: '$149.99' },
        { title: 'Payroll Quarterly & Annual Filing', price: '$49.99' },
        { title: '1099 Form Filing', price: '$9.99' },
    ];

    return (
        <div className="prices-page-wrapper">
            <NavBar />
            
            {/* Hero Section */}
            <div className="prices-hero">
                <div className="prices-hero-content">
                    <h1>Transparent Pricing</h1>
                    <p>No hidden fees, no surprises. Professional tax services at competitive prices.</p>
                </div>
            </div>

            <div className="prices-container">
                <div className="prices-header">
                    <h2>Our Service Pricing</h2>
                    <p>Clear, straightforward pricing for all our tax services</p>
                </div>

                <div className="prices-table-container">
                    <div className="prices-table">
                        <div className="table-header">
                            <div className="table-column service-column">Service</div>
                            <div className="table-column price-column">Price</div>
                        </div>
                        {services.map((service, index) => (
                            <div className="table-row" key={index}>
                                <div className="table-column service-column">
                                    {service.title}
                                </div>
                                <div className="table-column price-column">
                                    {service.price}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* CTA Section */}
                <div className="prices-cta">
                    <h2>Need Help Choosing the Right Service?</h2>
                    <p>Contact us for a free consultation and personalized quote</p>
                    <Link to="/contact" className="cta-button">Get Free Consultation</Link>
                </div>
            </div>

            <Whatsapp />
            <ScrollTop />
            <Footer />
        </div>
    );
};

export default PricesSection;